const SIMILAR_LIFESTYLE_PERCENT = 80

/**
 * Chooses the subheading based on how much of today's income the plan replaces.
 *
 * Compares the raw percentage; the chart rounds for display.
 */
export function getSubheadingMessage({ achievedPercent, planOnTrack }) {
  const replacementPercent = achievedPercent ?? 0

  if (replacementPercent < SIMILAR_LIFESTYLE_PERCENT) {
    return 'That means living on less than you do today.'
  }

  if (planOnTrack && replacementPercent > SIMILAR_LIFESTYLE_PERCENT) {
    return 'That results in higher spending power than you have today.'
  }

  return 'That helps you live a similar lifestyle to today.'
}
